import { VolumeNetworkList } from '@/components/resources/VolumeNetworkList';

export function VolumesPage() {
  return <VolumeNetworkList kind="volume" />;
}
